import { S3Client } from '@aws-sdk/client-s3';

const client = new S3Client({
  region: 'BTC',
  credentials: {
    accessKeyId: process.env.S3_ACCESS_KEY_ID!,
    secretAccessKey: process.env.S3_SECRET_ACCESS_KEY!
  },
  endpoint: process.env.S3_HTTPS_ENDPOINT!,
  apiVersion: 's3',
  forcePathStyle: true,
  requestHandler: {
    requestTimeout: 30000,
    httpsAgent: {
      keepAlive: true,
      maxSockets: 50
    }
  }
});

export default client;
